import ConsultantProjectIndexRow from './ConsultantProjectIndexRow';
export default ConsultantProjectIndexRow;